import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { deleteGroup } from '../../../services/groupsService'
import { GroupContext } from '../GroupContextProvider'

export default function DeleteGroupDialogOverlay({ ...overlay }) {
  const { t } = useTranslation()
  const { currentGroupData, fetchCurrentGroupData } = useContext(GroupContext)
  const { error } = useNotifications()

  const confirmBtnOnClick = async () => {
    try {
      overlay.close()
      await deleteGroup(currentGroupData.id)
      fetchCurrentGroupData()
    } catch (err) {
      error(
        t('group.errors.tombstoningDroup', {
          defaultValue: `Error tombstoning group: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('group.summary.dialogOverlay.delete.heading', 'Delete Group')}
      subtitle={currentGroupData.id}
      size="sm"
    >
      <Paragraph size="sm">
        {t('group.summary.dialogOverlay.delete.body', 'Are you sure you want to delete this group?')}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
